import { render, staticRenderFns } from "./RaPet.vue?vue&type=template&id=1a0cd0b8&scoped=true&"
import script from "./RaPet.vue?vue&type=script&lang=js&"
export * from "./RaPet.vue?vue&type=script&lang=js&"
import style0 from "./RaPet.vue?vue&type=style&index=0&id=1a0cd0b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0cd0b8",
  null
  
)

export default component.exports